import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useParams, Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export default function CardAlert() {
  const { eventID } = useParams();

  return (
    <Card variant="contained" sx={{ m: 1.5, flexShrink: 0 }}>
      <CardContent>                      
        <List dense>                
          <ListItem key={0} disablePadding sx={{ display: 'inline' }} component={Link} to={`/explore/${eventID}`} target='_blank'>                        
            <ListItemText primary= 'View as Public' />               
          </ListItem>        
          <ListItem key={1} disablePadding sx={{ display: 'block' }} button component={Link} to={`/join/${eventID}`} target='_blank'>                        
              <ListItemText primary= 'View as Attendant' />          
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
}
